import React, { PureComponent } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import VerticalSpace from "./components/VerticalSpace";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import { Route } from "react-router-dom";
import Button from "@material-ui/core/Button";
import AppConfig from "../../config/appconfig.json";
import Select from "react-select";
import $ from "jquery";
import KBELogo from "../account/img/kbe-Logo-66454.png";

class ChangeAppointment extends PureComponent {
    constructor(props) {
        super(props);
        const system = this.props.location.state
            ? this.props.location.state.airconsystem
            : null;
        const oldDate = this.props.location.state.AppointmentDate;
        const datetime = oldDate.split(',');
        const originalDate = moment(datetime[0], "DD MMM YYYY");
        // console.log(originalDate);

        const addressText = this.props.location.state.Address;
        const addressSplit = addressText.split(',');
        const postalcodeTrim = addressSplit[2].trim();
        // console.log(postalcode);

        this.state = {
            airconsystem: system,
            showErrorSlot: false,
            scheduleSid: this.props.location.state.ScheduleSid,
            appointmentDate: this.props.location.state.AppointmentDate,
            address: this.props.location.state.Address,
            system: this.props.location.state.System,
            availableDates: [],
            startDate: originalDate,
            currDatePickerMonth: originalDate.month() + 1,
            includeDates: [],
            includeTimes: [],
            postalcode: postalcodeTrim,
            selectedslot: ""
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.getApptSlot = this.getApptSlot.bind(this);
        this.updateTimingBasedOnSelectedDate = this.updateTimingBasedOnSelectedDate.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getApptSlot(this.state.postalcode, this.state.currDatePickerMonth);

        // Disable virtual keyboard
        $(document).ready(function () {
            if (window.Modernizr.touch) {
                // Disable keyboard by adding readonly attribute to field
                $('.data-disable-touch-keyboard').attr('readonly', 'readonly');
                $('input[role="combobox"]').attr('readonly', 'readonly');
            }
        });
    }

    handleDateChange(date) {
        this.setState({ startDate: date, currDatePickerMonth: date.month() + 1 });
        this.updateTimingBasedOnSelectedDate(date);
    }

    handleMonthChange(newDate) {
        const newMonth = moment(newDate._d).month() + 1;
        this.setState({ currDatePickerMonth: newMonth });
        this.getApptSlot(this.state.postalcode, newMonth);
    }

    handleTimeChange(e) {
        this.setState({ selectedslot: e.value, showErrorSlot: false });
    }

    handleSubmit(e) {
        e.preventDefault();
    }

    getApptSlot(postalcode, month) {
        if (postalcode === "") {
            return;
        }
        let isGetApptSlotFailed = false;
        const request = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                postalcode: postalcode,
                month: month.toString()
            })
        };
        // console.log(request);
        // Call Back-End Services
        fetch(`${AppConfig.BACK_END_URL}/APIAppt/GetAppSlot`, request)
            .then(response => {
                // console.log(response);
                if (response.ok === false) {
                    isGetApptSlotFailed = true;
                }
                return response.json();
            })
            .then(json => {
                if (isGetApptSlotFailed) {
                } else {
                    const respObj = JSON.parse(json);
                    // console.log(respObj);
                    if (respObj) {
                        // only show today's date and the future
                        const filteredDates = respObj.filter(e =>
                            moment(e.dates, "DD/MM/YYYY").isAfter(moment().add(-1, "days"))
                        );
                        // console.log(filteredDates);
                        this.setState({ availableDates: filteredDates });
                        let list = [];
                        for (let i = 0; i < filteredDates.length; i++) {
                            const date = moment(filteredDates[i].dates, "DD/MM/YYYY");
                            if (i === 0) {
                                this.setState({
                                    startDate: date,
                                    currDatePickerMonth: date.month() + 1
                                });
                                this.updateTimingBasedOnSelectedDate(date);
                            }
                            list.push(date);
                        }
                        // console.log(list);
                        this.setState({ includeDates: list });
                    }
                }
            })
            .catch(() => {
                console.log(
                    "Something went wrong when retrieving appointment slot. Please try again."
                );
            });
    }

    updateTimingBasedOnSelectedDate(date) {
        // find available times
        const sameDate = this.state.availableDates.filter(
            e => moment(e.dates, "DD/MM/YYYY").diff(date, "days") === 0
        );
        // console.log(sameDate);
        if (sameDate.length > 0) {
            if (sameDate[0].timing) {
                let timeList = [];
                sameDate[0].timing.forEach(elm => {
                    timeList.push({ value: elm, label: elm });
                });
                this.setState({ includeTimes: timeList });
                // console.log(timeList);
            }
        }
    }

    render() {
        const ChangeAppointmentButtonSubmit = props => (
            <Route
                render={({ history }) => (
                    <div>
                        <Button
                            variant="outlined"
                            style={{ width: "100%" }}
                            onClick={() => {
                                // console.log(this.state.airconsystem);
                                // console.log(this.state.scheduleSid);
                                // console.log(this.state.appointmentDate);
                                // console.log(this.state.address);
                                // console.log(this.state.system);
                                //   history.push({
                                //     pathname: "/change_appt",
                                //     state: { airconsystem: this.state.airconsystem }
                                //   });
                                if (this.state.selectedslot === "") {
                                    this.setState({ showErrorSlot: true });
                                    return;
                                }

                                let isChangeApptFailed = false;
                                const request = {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({
                                        ScheduleSid: this.state.scheduleSid,
                                        DateAppt: moment(this.state.startDate).format("DD/MM/YYYY"),
                                        Slot: this.state.selectedslot
                                    })
                                };
                                // console.log(request);
                                // Call Back-End Services
                                fetch(`${AppConfig.BACK_END_URL}/APIAppt/ChangeAppt`, request)
                                    .then(response => {
                                        // console.log(response);
                                        if (response.ok === false) {
                                            isChangeApptFailed = true;
                                        }
                                        return response.json();
                                    })
                                    .then(json => {
                                        if (isChangeApptFailed) {
                                        } else {
                                            const respObj = JSON.parse(json);
                                            // console.log(respObj);
                                            if (respObj) {
                                                history.push({ pathname: "/" });
                                            }
                                        }
                                    })
                                    .catch(() => {
                                        console.log(
                                            "Something went wrong when changing appointment slot. Please try again."
                                        );
                                    });
                            }}
                        >
                            Change Appointment
                  </Button>
                    </div>
                )}
            />
        );

        return <div>
            <div className="account">
                <div className="account__wrapper">
                    <div className="account__card">
                        <div className="account__head">
                            <img src={KBELogo} alt="logo" />
                        </div>
                        <div className="card__title">
                            <center>
                                <h4 className="bold-text">Change Appointment</h4>
                            </center>
                            <br />
                        </div>
                        <form className="form form--horizontal" onSubmit={this.handleSubmit}>
                            <div className="form__form-group">
                                <label className="form__form-group-label">System: </label>
                                <div className="form__form-group-field">
                                    <span>{this.state.system}</span>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <label className="form__form-group-label">Address: </label>
                                <div className="form__form-group-field">
                                    <span>{this.state.address}</span>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <label className="form__form-group-label">Original Date: </label>
                                <div className="form__form-group-field">
                                    <span>{this.state.appointmentDate}</span>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <label className="form__form-group-label">New Date: </label>
                                <div className="form__form-group-field">
                                    <DatePicker
                                        dateFormat="DD/MM/YYYY"
                                        selected={this.state.startDate}
                                        onChange={this.handleDateChange}
                                        includeDates={this.state.includeDates}
                                        forceShowMonthNavigation={true}
                                        onMonthChange={this.handleMonthChange}
                                        className="form__form-group-select data-disable-touch-keyboard"
                                        popperPlacement="top"
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <label className="form__form-group-label">New Slot: </label>
                                <div className="form__form-group-field">
                                    <Select
                                        name="slot"
                                        value={this.state.selectedslot}
                                        options={this.state.includeTimes}
                                        onChange={this.handleTimeChange}
                                        clearable={false}
                                        className="form__form-group-select data-disable-touch-keyboard"
                                        required={true}
                                    />
                                </div>
                                {this.state.showErrorSlot ? (
                                    <div className="form__form-group-field">
                                        <span className="list-text-red">
                                            Please select a slot
                                        </span>
                                    </div>
                                ) : (
                                        <span />
                                    )}
                            </div>
                            <div className="form__form-group">
                                <Grid container spacing={24}>
                                    <Grid item xs={3} />
                                    <Grid item xs={6}>
                                        <ChangeAppointmentButtonSubmit />
                                    </Grid>
                                    <Grid item xs={3} />
                                </Grid>
                                <VerticalSpace />
                            </div>
                        </form>
                        <SimpleBottomNavigation value={1} />
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default ChangeAppointment;


// WEBPACK FOOTER //
// ./src/pages/main/ChangeAppointment.js